import { useEffect, useRef, useState } from "react";

type TUseShowMapArgs = {
  value?: string | object;
  error?: object;
  isValidating?: boolean;
  displayMap?: boolean;
};

// May need to eventually have this (and all Inputs) take in and use an isValid prop.
const useShowMap = ({
  value,
  error,
  isValidating,
  displayMap = true,
}: TUseShowMapArgs): boolean => {
  const showMap = displayMap && value && !error;
  const justValidated = usePrevious(isValidating) && !isValidating;
  const justCleared = usePrevious(value) && !value;
  const wasShowingMap = useRememberIf(justValidated || justCleared, showMap);
  return showMap && wasShowingMap;
};

const useRememberIf = (shouldUpdate, newValue) => {
  const [value, setValue] = useState();
  useEffect(() => {
    if (shouldUpdate) {
      setValue(newValue);
    }
  });
  return value;
};

const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export { useShowMap, TUseShowMapArgs };
